import React, { ReactNode } from 'react';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  name: string;
  [key: string]: any; // For additional props
}

const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, name, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${name}-tab-panel`}
      aria-labelledby={`${name}-tab`}
      {...other}
    >
      {value === index && <div className="px-4 pb-2 pt-1">{children}</div>}
    </div>
  );
};

export default TabPanel;
